import * as React from 'react';
import { Box, lighten, useTheme } from '@mui/material';

export type InformationCardCompletionProps = {
    completedCount: number;
    totalCount: number;
    singularLabel?: string;
    plurialLabel?: string;
};

export const InformationCardCompletion: React.FunctionComponent<InformationCardCompletionProps> =
    function (props) {
        const {
            completedCount,
            totalCount,
            singularLabel = 'information complétée',
            plurialLabel = 'informations complétées',
        } = props;
        const { palette } = useTheme();
        const wrapperSx = {
            color: lighten(palette.text.primary, 0.5),
            flexBasis: '100%',
            fontSize: '13px',
            fontWeight: '500',
            lineHeight: '20.8px',
        };

        const label = (
            <>
                {completedCount}/{totalCount} {completedCount > 1 ? plurialLabel : singularLabel}
            </>
        );

        return <Box sx={wrapperSx}>{label}</Box>;
    };
